export const convertRangeDateToStartDTFormat = (rangeDate) => {
    return rangeDate.map(date => date.body);
};
